import { render } from "./instagram2.vue?vue&type=template&id=05eb7ef5"
import script from "./instagram2.vue?vue&type=script&lang=js"
export * from "./instagram2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__